module.exports = __webpack_public_path__ + "img/logo_google_pay.6492cb8.svg";